import { usePricingPlans } from '~teacher/hook/usePlanPrices';

// TODO This may not be useful anymore
export function useProPlanIds() {
  return usePricingPlans({
    select: ({ pro, essentials }) => {
      return [
        pro.yearly.stripePriceid,
        pro.monthly.stripePriceid,
        essentials.yearly.stripePriceid,
        essentials.monthly.stripePriceid,
      ];
    },
  });
}
